import { FieldError, Merge, FieldErrorsImpl } from "react-hook-form";

export const getErrorMessage = (error: FieldError | Merge<FieldError, FieldErrorsImpl<any>>) => {
    if (!error) return null;
    if (typeof error.message === 'string') return error.message;
    return 'Invalid input';
};